import * as z from 'zod'

import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const schema = z.preprocess((values) => {
  const valuesCopy = { ...(values as Record<string, any>) }
  if (!valuesCopy.previous_insurance_in_last_5y) {
    valuesCopy.cancelled_by_previous_insurer = undefined
    valuesCopy.number_of_claims_in_last_5y = 0
  }

  return {
    ...valuesCopy,
  }
}, BaseSchema_LiabilityV1GetsafeDe)

export default schema
